<template>
  <a-card class="NormComputeSet">
    <a-form-model :model="ruleForm.data" :rules="ruleForm.rule" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" ref="ruleForm">
      <a-row>
        <a-col :span="8">
          <a-form-model-item label="采集设备" ref="name" prop="name" :label-col="{ span: 4 }">
            <a-select style="min-width: 180px" disabled mode="multiple" show-search allowClear v-model="ruleForm.data.deviceType" placeholder="请选择">
              <a-select-option :value="item.id" v-for="item in equipmentList" :key="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="5">
          <a-form-model-item label="粗分阈限" class="age">
            <div class="age-cont">
              <a-form-model-item :wrapper-col="{ span: 24 }" prop="minSocre">
                <a-input-number v-model="ruleForm.data.minSocre" disabled style="width: 100%" />
              </a-form-model-item>
              <span style="margin: 0 10px 20px">-</span>
              <a-form-model-item :wrapper-col="{ span: 24 }" prop="maxScore">
                <a-input-number v-model="ruleForm.data.maxScore" disabled style="width: 100%" />
              </a-form-model-item>
            </div>
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item label="采集时间段" ref="times">
            <a-range-picker disabled v-model="ruleForm.times" :show-time="{ format: 'HH:mm' }" valueFormat="YYYY-MM-DD HH:mm:ss" :placeholder="['开始时间', '结束时间']" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row style="padding: 0 20px">
        <a-checkbox v-model="ruleForm.area" disabled> 区域代表性 </a-checkbox>
        <span v-show="ruleForm.area" style="position: relative">
          <a-input-number v-model="ruleForm.data.areaCharacteristicSize" disabled style="width: 150px; margin: 0 20px 0 10px" />
          <template>
            <span class="area areas-active" v-for="(item, index) in areas" :key="index">{{ item.label }}</span>
          </template>
          <p class="errMsg" v-if="ruleForm.errMsg">请填写区域样本量</p>
        </span>
      </a-row>
    </a-form-model>
    <div class="content">
      <div class="head">
        <h1>常模对比表</h1>
        <a-button @click="exportView()">导出</a-button>
      </div>
      <div class="table" style="padding: 0 19px; margin-top: 15px">
        <a-table :columns="contrastColumns" row-key="id" :scroll="{ y: 480 }" :pagination="false" :dataSource="contrastStr.tableRelevant.tableDataSource">
          <div slot="sampleCount" slot-scope="text">
            {{ text.sampleCount }}
          </div>
          <div slot="average" slot-scope="text">
            <div class="box">
              {{ text.average ? text.average : '--' }}
              <span class="people" v-if="text.thisAvgScoreHasUpdate">人工</span>
            </div>
          </div>
          <div slot="standardDeviation" slot-scope="text">
            <div class="box">
              {{ text.standardDeviation ? text.standardDeviation : '--' }}
              <span class="people" v-if="text.thisStdHasUpdate">人工</span>
            </div>
          </div>
        </a-table>
      </div>
    </div>

    <div class="content">
      <div class="head">
        <h1>年龄发展趋势 <span>( 以年龄为横轴 )</span></h1>
        <div class="genders">
          <div @click="changeGender(item.id)" :class="ageChart.current == item.id ? 'active item' : 'item'" v-for="item in ageChart.genders" :key="item.id">{{ item.name }}</div>
        </div>
      </div>
      <div class="ageChart">
        <div id="AgeChartDetail" style="height: 290px; width: 100%"></div>
        <div id="AgeChartContent" v-if="!TableCreated" style="height: 290px; width: 100%; display: flex; align-items: center; justify-content: center">暂无数据</div>
      </div>
    </div>
    <footer-tool-bar v-if="!historyDatail">
      <div class="btns" v-if="$route.query.pegetype != 'apply'">
        <a-button @click="backpage()">返回</a-button>
        <a-button type="primary" @click="pass()">通过</a-button>
        <a-button type="danger" @click="reject()">拒绝</a-button>
      </div>
      <div v-else>
        <a-button @click="backpage()">返回</a-button>
      </div>
    </footer-tool-bar>
    <!-- 通过 常模应用设置-->
    <a-modal :centered="true" v-model="appSet.visible" :title="appSet.title" :confirm-loading="appSet.confirmLoading" @ok="appSetOk" @cancel="appSetCancel" okText="应用并上线" width="600px">
      <a-form-model ref="appSetForm" :labelCol="{ span: 6 }" :wrapperCol="{ span: 17 }" :model="appSet.data" :rules="appSet.rules">
        <a-form-model-item label="游戏名称" prop="contentName">
          <a-input v-model="appSet.data.contentName" disabled :maxLength="25" placeholder="请输入" />
        </a-form-model-item>
        <a-form-model-item label="应用设备" prop="deviceType">
          <a-select show-search allowClear mode="multiple" v-model="appSet.data.deviceType" disabled placeholder="请选择">
            <a-select-option :value="item.id" v-for="item in equipmentList" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="是否生效" prop="isTakeEffect">
          <a-radio-group v-model="appSet.data.isTakeEffect">
            <a-radio :value="true">是</a-radio>
            <a-radio :value="false">否</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import $Bus from '@/pages/projectImpl/js/eventBus'
import FooterToolBar from '@/components/tool/FooterToolBar'
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import xlsx from 'xlsx'
import moment from 'moment'

const contrastColumns = [
  { title: '年龄', dataIndex: 'age', align: 'center' },
  { title: '性别', dataIndex: 'genderName', align: 'center' },
  { title: '样本量', scopedSlots: { customRender: 'sampleCount' }, align: 'center' },
  { title: '平均分', scopedSlots: { customRender: 'average' }, align: 'center' },
  { title: '标准差', scopedSlots: { customRender: 'standardDeviation' }, align: 'center' },
]

export default {
  name: 'NormComputeSet',
  components: { FooterToolBar },
  props: ['historyDatail', 'lastId', 'lastDeviceType'],
  data() {
    return {
      equipmentList: [
        { id: 1, name: '其他' },
        { id: 2, name: '键盘' },
        { id: 4, name: '鼠标' },
        { id: 8, name: '触摸屏' },
        { id: 16, name: '全部' },
      ],
      query: {
        id: '',
        type: '',
        version: '',
        ContentAlgorithmCodeConfigId: '',
      },
      // 生成数据
      ruleForm: {
        loading: false,
        area: false,
        errMsg: false,
        times: [],
        data: {
          deviceType: [],
          minSocre: null,
          maxScore: null,
          startTime: undefined,
          endTime: undefined,
          contentAlgorithmCodeConfigId: +this.$route.query.ContentAlgorithmCodeConfigId,
          // contentAlgorithmCodeConfigId:272,
          areaCharacteristicSize: undefined,
        },
        rule: {
          minSocre: [
            { required: false, message: '请填写最小值', trigger: 'blur' },
            { min: 1, max: 150, message: '最小值 1 ~ 150', trigger: ['change', 'blur'], type: 'number' },
          ],
          maxScore: [
            { required: false, message: '请填写最大值', trigger: 'blur', type: 'number' },
            { min: 1, max: 150, message: '最大值 1 ~ 150', trigger: ['change', 'blur'], type: 'number' },
          ],
        },
      },
      // 常模对比表
      contrastColumns,
      contrastStr: {
        tableRelevant: tableRelevant.call(this, this.getList),
      },
      //年龄发展趋势
      ageChart: {
        genders: [
          { id: 0, name: '全部' },
          { id: 1, name: '男' },
          { id: 2, name: '女' },
        ],
        current: 0,
        xAxis: [],
        yAxis: [],
        stds: [],
      },
      areas: [],
      detailId: '',

      appSet: {
        visible: false,
        title: '常模应用设置',
        confirmLoading: false,
        data: {
          id: '',
          contentName: sessionStorage.getItem('currentName'),
          deviceType: [],
          isTakeEffect: true,
        },
        rules: {
          contentName: [{ required: true, message: '请输入游戏名称', trigger: 'blur' }],
          deviceType: [{ required: true, message: '请选择应用设备', trigger: 'blur' }],
          isTakeEffect: [{ required: true, message: '请选择是否生效', trigger: 'blur' }],
        },
      },
      excelTitle: '',
      TableCreated: false,
      lastVersionnorm: '', //上一版本
      normId: '',
    }
  },
  mounted() {
    this.query = {
      id: this.$route.query.id,
      type: this.$route.query.type,
      version: this.$route.query.version,
      ContentAlgorithmCodeConfigId: this.$route.query.ContentAlgorithmCodeConfigId,
    }
    let name = sessionStorage.getItem('currentName')
    let version = this.$route.query.version
    if (version) {
      this.excelTitle = name + '(' + version + ')' + ' 常模配置'
    } else {
      this.excelTitle = name + ' 常模配置'
    }

    this.$store.commit(
      'account/set_breadcrumb',
      this.$store.state.account.breadcrumb
        .map((m) => {
          if (m.name === '常模配置') {
            m.path = this.$store.getters['content/getNormInfo']().fullPath
          }
          return m
        })
        .filter((f) => f.name !== '常模配置' || typeof f.path !== 'undefined')
    )

    if (this.historyDatail) {
      this.getLastVersionNorm()
    } else {
      this.getDetail()
    }
  },
  methods: {
    // 获取上一版本
    getLastVersionNorm() {
      let params = {
        id: this.lastId,
        deviceType: this.lastDeviceType > 1 && (this.lastDeviceType != 2) & (this.lastDeviceType != 4) & (this.lastDeviceType != 8) ? 1 : this.lastDeviceType,
        ContentAbilityId: this.$route.query.id,
      }
      this.$http.NormSet.GetLastVersionNorm(params).then((res) => {
        const { data } = res
        this.TableCreated = true
        for (let key in data) {
            for (let k in this.ruleForm.data) {
              if (key == k && key != 'deviceType') {
                this.ruleForm.data[key] = data[key]
              }
            }
          }
          this.equipmentList.forEach((v) => {
            if ((v.id | data.deviceType) == data.deviceType) {
              this.ruleForm.data.deviceType.push(v.id)
            }
          })
          if (data.areaCharacteristicSize) {
            this.ruleForm.area = true
          }

          if (data.areaCharacteristicDescriptions && data.areaCharacteristicDescriptions != '[]') {
            try {
              this.areas = JSON.parse(data.areaCharacteristicDescriptions)
            } catch (error) {
              this.areas = []
            }
          }
          this.detailId = data.id
          this.lastVersionnorm = data.lastVersionnorm
          if (data.startTime && data.endTime) {
            this.ruleForm.times = [moment(data.startTime), moment(data.endTime)]
          }
          this.createNorm(data.norms)
      })
    },
    getDetail() {
      let params = {
        id: this.$route.query.recordId,
      }
      this.$http.NormSet.getDetail(params)
        .then((res) => {
          const { data } = res
          this.TableCreated = true
          for (let key in data) {
            for (let k in this.ruleForm.data) {
              if (key == k && key != 'deviceType') {
                this.ruleForm.data[key] = data[key]
              }
            }
          }
          this.equipmentList.forEach((v) => {
            if ((v.id | data.deviceType) == data.deviceType) {
              this.ruleForm.data.deviceType.push(v.id)
            }
          })
          if (data.areaCharacteristicSize) {
            this.ruleForm.area = true
          }
          if (data.areaCharacteristicDescriptions && data.areaCharacteristicDescriptions != '[]') {
            try {
              this.areas = JSON.parse(data.areaCharacteristicDescriptions)
            } catch (error) {
              this.areas = []
            }
          }
          this.detailId = data.id
          this.lastVersionnorm = data.lastVersionnorm
          if (data.startTime && data.endTime) {
            this.ruleForm.times = [moment(data.startTime), moment(data.endTime)]
          }
          this.createNorm(data.norms)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 生成
    createNorm(data) {
      console.log(data)
      this.contrastStr.tableRelevant.tableDataSource = data
      let thisData = data.filter((m) => m.gender == 0)
      thisData.forEach((v) => {
        this.ageChart.xAxis.push(v.age || 0)
        this.ageChart.yAxis.push(v.average || 0)
        this.ageChart.stds.push(v.standardDeviation || 0)
      })
      this.$nextTick(() => {
        this.AgeChart()
      })
    },

    // 年龄发展趋势 切换性别
    changeGender(gender) {
      this.ageChart.xAxis = []
      this.ageChart.yAxis = []
      this.ageChart.stds = []
      this.ageChart.current = gender
      let data = this.contrastStr.tableRelevant.tableDataSource.filter((m) => m.gender == gender)
      data.forEach((v) => {
        console.log(v)
        this.ageChart.xAxis.push(v.age)
        this.ageChart.yAxis.push(v.average || 0)
        this.ageChart.stds.push(v.standardDeviation || 0)
      })
      this.AgeChart()
    },
    // 年龄发展趋势折线
    AgeChart() {
      console.log(this.ageChart.stds)
      const CharData = this.contrastStr.tableRelevant.tableDataSource.filter((f) => f.gender === this.ageChart.current)
      const AgeChartBox = document.getElementById('AgeChartDetail')
      let AgeChart = this.$echarts.init(
        AgeChartBox,
        {},
        {
          renderer: 'svg',
        }
      )
      var option = {
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: CharData.map((m) => m.age),
        },
        tooltip: {
          trigger: 'axis',
          formatter: (val) => {
            return `<div>
                                <p>${val[0].name}</p>
                                <p><span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:rgb(254,143,7);"></span>样本量：${
                                  CharData[val[0].dataIndex].sampleCount == null ? '' : CharData[val[0].dataIndex].sampleCount
                                }</p>
                                <p><span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:rgb(7,93,254);"></span>平均分：${
                                  CharData[val[0].dataIndex].average || 0
                                }</p>
                                <p><span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:rgb(228,240,255);"></span>标准差：${
                                  CharData[val[0].dataIndex].standardDeviation || 0
                                }</p>
                                <p></p>
                            </div>`
          },
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            name: '平均分',
            data: CharData.map((m) => m.average || 0),
            type: 'line',
            symbol: 'circle',
            // stack: 'Total',
            areaStyle: {
              color: 'rgb(228,240,255)',
              emphasis: {
                color: 'rgb(228,240,255)',
              },
            },
            lineStyle: {
              normal: {
                color: 'rgb(7,93,254)',
              },
            },
            itemStyle: {
              normal: {
                color: 'rgb(7,93,254)', //拐点颜色
                borderColor: 'rgb(7,93,254)', //拐点边框颜色
                borderWidth: 3, //拐点边框大小
              },
            },
            symbolSize: 5, //设定实心点的大小
          },
        ],
      }
      AgeChart.setOption(option)
      setTimeout(() => {
        var path = document.querySelectorAll("#AgeChartDetail path[fill='rgb(7,93,254)']")
        var itemChar = document.querySelectorAll('#AgeChartDetail .item-char')
        for (let i = 0; i < itemChar.length; i++) {
          itemChar[i].remove()
        }
        for (let i = 0; i < path.length; i++) {
          var split = path[i]
            .getAttribute('transform')
            .match(/(?<=\()(.+?)(?=\))/g)[0]
            .split(',')
          var div = document.createElement('div')
          div.innerHTML = '<span></span>'
          div.className = 'item-char'
          div.style.top = split[split.length - 1] + 'px'
          div.style.left = split[split.length - 2] + 'px'
          AgeChartBox.appendChild(div)
          // console.log(split[split.length - 1], split[split.length - 2]);
        }
      }, 500)
    },

    // 返回
    backpage() {
      let pathQuery = ''
      if (this.$route.query.pegetype != 'apply') {
        pathQuery = "contentId=" + this.$route.query.contentId + '&activekey=2&id=' + this.query.id + '&type=' + this.query.type + '&version=' + this.query.version + '&ContentAlgorithmCodeConfigId=' + this.query.ContentAlgorithmCodeConfigId
      } else {
        pathQuery = "contentId=" + this.$route.query.contentId + '&activekey=1&id=' + this.query.id + '&type=' + this.query.type + '&version=' + this.query.version + '&ContentAlgorithmCodeConfigId=' + this.query.ContentAlgorithmCodeConfigId
      }
      this.$router.push('/content/normSeting?' + pathQuery)
    },
    // 通过
    pass() {
      this.appSet.data.deviceType = []
      let params = {
        id: this.detailId,
      }
      this.$http.NormSet.GetGameVersionNorm(params)
        .then((res) => {
          const { data } = res
          this.equipmentList.forEach((v) => {
            if ((v.id | data.deviceType) == data.deviceType) {
              this.appSet.data.deviceType.push(v.id)
            }
          })
          this.appSet.data.contentName = data.name + ' v' + data.version
          this.appSet.data.id = data.id
          this.appSet.visible = true
        })
        .catch((err) => {
          console.log(err)
        })
    },
    appSetCancel() {
      this.appSet.visible = false
      this.$refs.appSetForm.resetFields()
    },
    appSetOk() {
      this.$refs.appSetForm.validate((valid) => {
        if (valid) {
          let formData = new FormData()
          formData.append('id', this.appSet.data.id)
          formData.append('isTakeEffect', this.appSet.data.isTakeEffect)
          this.$http.NormSet.NormAudit(formData)
            .then((res) => {
              console.log(res)
                this.appSet.visible = false
                this.backpage()
             
            })
            .catch((err) => {
              console.log(err)
            })
        } else {
        }
      })
    },
    // 拒绝
    reject() {
      let formData = new FormData()
      formData.append('id', this.detailId)
      formData.append('status', 0)
      this.$http.NormSet.NormReject(formData)
        .then(() => {
          this.backpage()
        })
        .catch((err) => {
          console.log(err)
        })
    },

    // 导出
    exportView(text) {
      let params = {
        id: this.$route.query.recordId,
      }
      this.$http.NormSet.getDetail(params)
        .then((res) => {
          const { data } = res
          const arr = [contrastColumns.map((m) => m.title)]
          arr[0].unshift('版本名称')
          arr[0].unshift('游戏名称')
          data.norms.forEach((f) => {
            arr.push([
              sessionStorage.getItem('currentName'),
              'v' + this.$route.query.version,
              f.age,
              f.gender == 0 ? 'all' : f.gender == 1 ? 'male' : 'female',
              f.existsSampleCount,
              f.existsSampleAvgScore,
              f.existsSampleStd,
            ])
          })
          const aoa = xlsx.utils.aoa_to_sheet(arr)
          const book = xlsx.utils.book_new()
          xlsx.utils.book_append_sheet(book, aoa, '第一页')
          xlsx.writeFile(book, this.excelTitle + '.xlsx')
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
}
</script>

<style scoped lang="less">
.age /deep/.ant-form-item {
  height: 59px;
  margin-bottom: 0;
}

.age-cont {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/deep/ .ant-calendar-picker-input {
  width: 300px;
}
.btns {
  width: 240px;
  display: flex;
  justify-content: space-between;
}
/deep/ .ant-calendar-picker-input {
  width: 300px;
}
.area {
  display: inline-block;
  padding: 0 10px;
  border: 1px dotted #ccc;
  border-radius: 5px;
}

.content {
  margin-top: 50px;
  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    h1 {
      font-weight: 600;
      margin: 0;
      span {
        font-size: 14px;
        color: #a0a0a0;
        font-weight: normal;
      }
    }
    .genders {
      display: flex;
      .item {
        padding: 0 20px;
        height: 30px;
        display: flex;
        border: 1px solid #ccc;
        align-items: center;
        border-radius: 5px;
        cursor: pointer;
      }
      .active {
        border-color: rgb(0, 82, 217);
        color: rgb(0, 82, 217);
      }
    }
  }
  .ageChart {
    width: 100%;
    height: 350px;
    position: relative;
    #AgeChartDetail {
      width: 100% !important;
      min-height: 300px;
    }
    #AgeChartContent {
      position: absolute;
      left: 0;
      top: 0;
      background-color: #fff;
    }

    /deep/ .item-char {
      width: 3px;
      height: 50px;
      background-color: rgb(255, 154, 51);
      position: absolute;
      transform: translate(-50%, -50%);

      &:before,
      &:after {
        content: '';
        background-color: rgb(255, 154, 51);
        width: 10px;
        height: 10px;
        display: block;
        position: absolute;
        left: -3.75px;
        top: 0;
        border-radius: 50%;
      }
      &:after {
        top: auto;
        bottom: 0;
      }

      span {
        width: 12px;
        height: 12px;
        background-color: rgb(7, 93, 254);
        border-radius: 50%;
        position: absolute;
        left: -4px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
}

.table-input {
  border: none;
  width: 60%;
  height: 100%;
  display: block;
  background: transparent;
  outline: none;
  text-align: center;
}
input[type='number'] {
  -moz-appearance: textfield;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.rawScore {
  width: 500px;
  height: 300px;
  background: rgb(226, 226, 226);
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  z-index: 9;
  padding: 15px;
  border-radius: 5px;

  .rawScoreChart {
    width: 100%;
    background: #fff;
    height: 270px;
    border-radius: 5px;
    .head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px 20px 0 20px;
      h1 {
        font-weight: 600;
        margin: 0;
        span {
          font-size: 14px;
          color: #a0a0a0;
          font-weight: normal;
        }
      }
      .groupedNum {
        display: flex;
        align-items: center;
        span {
          display: flex;
          flex-direction: column;
          margin-left: 10px;
          i {
            cursor: pointer;
          }
        }
      }
    }
    .chart {
    }
  }
}
.box {
  display: flex;
  justify-content: space-around;
  position: relative;
  .people {
    font-size: 12px;
    border: 1px solid #f00;
    border-radius: 5px;
    padding: 0 5px;
    color: #f00;
    cursor: pointer;
    position: absolute;
    right: 0;
  }
}
.areas-active {
  background-color: var(--color);
  color: #eee;
}
</style>
